import { defineStore } from 'pinia/dist/pinia'
import { loadKvChartData } from '@/service/Versorgungsatlas'
import { fillDataArraysKv } from '@/service/Versorgungsatlas'

export const useEvaluationKvStore = defineStore('evaluationKvList', {
    state: () => ({
        evaluationKvList: [],
        mapListKVValues: [],
        mapListLabels: [],
        latestYear: 0,
        auswid: 0,
        ausprid: 0,
    }),
    getters: {
        getEvaluationById: (state) => {
            return (auswid) => state.evaluationKvList.find((evaluation) => parseInt(evaluation.auswid) === parseInt(auswid))
        },
        getKVValuesData() {
            return this.mapListKVValues
        },
        getLatestYear() {
            return this.latestYear
        },
        getLabelsXAxis: (state) => {
            return (auswid, ausprid) => state.update(auswid, ausprid);
        }
    },
    actions: {
        update(auswid, ausprid) {
            let newLoadAuswid = (this.auswid != auswid)
            let newLoadAusprid = (this.ausprid != ausprid && ausprid != 0);

            if (newLoadAuswid) {
                this.loadKvChartData(auswid, ausprid,true);
            } else if (newLoadAusprid) {
                this.updateStates(auswid, ausprid);
            }

            return this.mapListLabels;
        },
        updateStates(auswid, ausprid) {
            let result = fillDataArraysKv(this.evaluationKvList, ausprid);

            this.mapListLabels = result[0]['mapLabels'];
            this.mapListKVValues = result[1]['kvValues'];
            this.auswid = auswid;
            this.ausprid = ausprid;
        },
        async loadKvChartData(auswid, ausprid, force = false) {
            if ((this.evaluationKvList?.length === 0) || force === true) {
                const resultSetAge = await loadKvChartData(auswid)
                this.evaluationKvList = resultSetAge.data ?? []
            }

            this.updateStates(auswid, ausprid);
        },
    },
})